import React, { useContext, useEffect, useState } from 'react';
import { Underage, Signature } from '../../../types/user';
import { DeleteAccountContext } from '..';
import {
  Section,
  ContainerContent,
} from '../../../components/Section/Box/styles';

import { Actions, Categories, Labels } from '../../../types/gtm';
import Icon from '../../../components/Section/Icon';
import Content from '../../../components/Section/Content';
import Action from '../../../components/Section/Action';

import svg from '../../../static/img/icon-open-menu.svg';

type ListButtonItem = {
  label: string;
  step: string;
  action: string;
};

export const ListMobileTopics = ({
  signatures,
  responsibleForUnderages,
  isUserB2BAccount,
  globoId,
}: {
  signatures: Signature[];
  responsibleForUnderages: Underage[];
  isUserB2BAccount: boolean;
  globoId: string;
}) => {
  const { setStep } = useContext(DeleteAccountContext);
  const [listButtons, setListButtons] = useState<ListButtonItem[]>([]);

  useEffect(() => {
    const items: ListButtonItem[] = [];

    if (signatures.length > 0) {
      items.push({
        label: 'Assinaturas',
        step: 'subscriptionsDetails',
        action: Actions.ClickToViewSubscriptionsDetails,
      });
    }

    if (responsibleForUnderages.length > 0) {
      items.push({
        label: 'Controle Parental',
        step: 'parentalDetails',
        action: Actions.ClickToViewParentalControlDetails,
      });
    }

    if (isUserB2BAccount === true) {
      items.push({
        label: 'Globo Ads',
        step: 'globoAdsDetails',
        action: Actions.ClickToViewGloboAdsDetails,
      });
    }

    setListButtons(items);
  }, [signatures, responsibleForUnderages, isUserB2BAccount]);

  if (listButtons.length === 0) {
    return <></>;
  }

  return (
    <Section className="mcv3-card" style={{ marginTop: 24, width: '100%' }}>
      <ContainerContent>
        <Content>
          {listButtons.map((item: ListButtonItem, index: number) => (
            <>
              <Action
                onClick={() => {
                  window.dataLayer.push({
                    event: 'customEventUserInteraction',
                    event_category: Categories.DeleteAccount,
                    event_action: item.action,
                    event_label: Labels.DeleteAccountPageInfo,
                    bd_suser_code: globoId,
                  });
                  setStep(item.step);
                }}
                theme="buttonSubscriptionActionList"
              >
                <p>{item.label}</p>
                <Icon width="13" svg={svg} alt="icon-open-menu" />
              </Action>
              {index < listButtons.length - 1 && <hr aria-hidden />}
            </>
          ))}
        </Content>
      </ContainerContent>
    </Section>
  );
};
